var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.292893 1.27329C-0.0976311 1.66277 -0.0976311 2.29423 0.292893 2.6837L3.58579 5.96775L0.292893 9.25179C-0.0976309 9.64126 -0.0976309 10.2727 0.292893 10.6622C0.683418 11.0517 1.31658 11.0517 1.70711 10.6622L5 7.37816L8.29289 10.6622C8.68342 11.0517 9.31658 11.0517 9.70711 10.6622C10.0976 10.2727 10.0976 9.64126 9.70711 9.25179L6.41421 5.96775L9.70711 2.6837C10.0976 2.29423 10.0976 1.66277 9.70711 1.27329C9.31658 0.883817 8.68342 0.883817 8.29289 1.27329L5 4.55733L1.70711 1.27329C1.31658 0.883817 0.683417 0.883817 0.292893 1.27329Z","fill":"#5C7783"}));
}

IconClose.defaultProps = {"width":"10","height":"11","viewBox":"0 0 10 11","fill":"none"};

module.exports = IconClose;

IconClose.default = IconClose;
